import React from 'react';
import { ReviewForm } from './components/ReviewForm';
export function App() {
  return <div className="min-h-screen bg-[#FAFAFA]" data-id="element-0">
      <ReviewForm data-id="element-1" />
    </div>;
}